import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Loading } from 'tdesign-react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import ListPanel from '@/components/ListPanel';
import ShadowCard from '@/components/ShadowCard';
import { reset } from '@/slices/execVariableSlice';
import Group from './Group';
import VariableTable from './VariableTable';
import SearchHeader from './SearchHeader';

function ClusterVariables({ loading, cluster, reset }) {
  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);

  return (
    <>
      <ListPanel header='查看变量'>
        <SearchHeader />
      </ListPanel>
      {!isEmpty(cluster) && (
        <Loading loading={loading} size='small'>
          <Body>
            <Group />
            <VariableTable />
          </Body>
        </Loading>
      )}
    </>
  );
}

export default connect(
  (state) => ({
    loading: state.execVariable.loading,
    cluster: state.execVariable.cluster,
  }),
  {
    reset,
  },
)(ClusterVariables);

const Body = styled(ShadowCard)`
  margin-top: 16px;
  margin-right: 20px;
  .shadow-card-body {
    padding: 0;
    display: flex;
  }
`;
